import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { StatusLogDto } from '@app/apiModules/DeploymentStatusDto';
import { AgGridModule } from 'ag-grid-angular';
@Component({
    standalone: true,
    selector: 'app-status-log',
    templateUrl: './status-log.component.html',
    styleUrls: ['./status-log.component.scss'],
    imports: [CommonModule, AgGridModule] // <-- Add AgGridModule here
})
export class StatusLogComponent implements OnInit {
  title = '';
  statusdata: StatusLogDto[] = [];

columnDefs = [
  { headerName: 'Service Name', field: 'serviceName', flex: 1, cellStyle: { textAlign: 'left' } },
  { headerName: 'Deployment Status', field: 'deploymentStatus', flex: 1, cellStyle: { textAlign: 'left' } },
  { headerName: 'Comments', field: 'comments', flex: 2, cellStyle: { textAlign: 'left', whiteSpace: 'normal' } },
  //{
  //  headerName: 'Build Url', field: 'buildNumber', flex: 2, cellStyle: { textAlign: 'left', whiteSpace: 'normal' },
  //  cellRenderer: params => {
  //    const lastSegment = params?.value.split("/").pop();
  //    let hyperLink = `<a class="ag-link" style="color: #1976d2; font-weight: 400; text-decoration: underline; cursor: pointer;">{lastSegment}</a>`;
  //    hyperLink = hyperLink.replace("{lastSegment}", lastSegment);
  //    return hyperLink;
  //  },
  //  onCellClicked: (params) => {
  //    window.open(params.value);
  //  }
  //}
];

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.title = this.data.title || '';
    if (this.data.popupcontent) {
      if (typeof this.data.popupcontent === 'string') {
        try {
          this.statusdata = JSON.parse(this.data.popupcontent);
        } catch (e) {
          console.error('Invalid Status Log:', e);
        }
        this.cdr.detectChanges(); // Force update
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
